import type { TareAppModel } from '../types/TareBridge';

import { getTareBridge } from './getTareBridge';
import { normalizeEnvironment } from '../../environment';
import { callPromiseSafely } from '../../util/callPromiseSafely';

/**
 * Normalizes the buildEnvironment field from the raw native bridge value.
 * Android sends uppercase ('PROD', 'QA'), iOS sends lowercase ('prod', 'qa').
 */
function normalizeAppModel(appModel: TareAppModel | null): TareAppModel | null {
    if (!appModel) {
        return null;
    }
    return {
        ...appModel,
        buildEnvironment: normalizeEnvironment(appModel.buildEnvironment),
    };
}

/**
 * Load the app model from the native module.
 */
export async function getAppModel(): Promise<TareAppModel | null> {
    const result = await callPromiseSafely(getTareBridge()?.getAppModel);
    return normalizeAppModel(result);
}

export function getAppModelSync(): TareAppModel | null {
    const result = getTareBridge()?.getAppModelSync?.() ?? null;
    return normalizeAppModel(result);
}
